import { Injectable, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppInfoConfig, ClientConfigProductName, ProductService } from '@frontend/vanilla/core';
import { Observable, firstValueFrom } from 'rxjs';

import { CasinoGeolocationClientConfig } from './client-config/casino-config';
import { HorseRacingGeoLocationClientConfig } from './client-config/horseracing.models';

@Injectable({
    providedIn: 'root',
})
export class GeolocationActivatorService {
    private casinoGeolocationConfig: CasinoGeolocationClientConfig = inject(CasinoGeolocationClientConfig);
    private horseRacingGeolocationConfig: HorseRacingGeoLocationClientConfig = inject(HorseRacingGeoLocationClientConfig);
    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly productService = inject(ProductService);
    private readonly appInfoConfig = inject(AppInfoConfig);

    async isActive(): Promise<boolean> {
        const product = this.getCurrentProduct();
        const serviceMap: Record<string, { whenReady: Observable<any>; isEnabled: boolean }> = {
            [ClientConfigProductName.CASINO]: this.casinoGeolocationConfig,
            [ClientConfigProductName.HORSERACING]: this.horseRacingGeolocationConfig,
            racebook: this.horseRacingGeolocationConfig,
        };
        const cfg = serviceMap[product];
        if (!cfg) {
            return false;
        }
        await firstValueFrom(cfg.whenReady);
        let isDisabledViaRoute = false;
        const disableFeaureQueryParameter = this.activatedRoute.snapshot.queryParamMap.get('_disableFeature');
        isDisabledViaRoute =
            disableFeaureQueryParameter
                ?.trim()
                ?.split(',')
                ?.some((queryParameterValue: string) => queryParameterValue?.toLowerCase() === 'geolocation') ?? false;
        return !isDisabledViaRoute && cfg.isEnabled;
    }

    private getCurrentProduct(): string {
        return this.productService.isSingleDomainApp ? this.productService.current.name.toLowerCase() : this.appInfoConfig.product.toLowerCase();
    }
}
